import React from 'react';
import { Lock, AlertTriangle } from 'lucide-react';
import { motion } from 'framer-motion';
interface FinalizeButtonProps {
  isComplete: boolean;
  isFinalized: boolean;
  onFinalize: () => void;
}
export function FinalizeButton({
  isComplete,
  isFinalized,
  onFinalize
}: FinalizeButtonProps) {
  if (isFinalized) {
    return <div className="mt-8 p-4 bg-surface-200 border border-surface-100 rounded-lg flex flex-col items-center justify-center text-center" data-id="element-146">
        <Lock className="text-emerald-500 mb-2" size={24} data-id="element-147" />
        <h3 className="text-lg font-semibold text-emerald-50" data-id="element-148">Day Locked</h3>
        <p className="text-sm text-gray-400 mt-1" data-id="element-149">
          You have successfully completed today's mission.
        </p>
      </div>;
  }
  return <div className="mt-8" data-id="element-150">
      {!isComplete && <div className="mb-4 flex items-start gap-3 p-3 bg-amber-900/20 border border-amber-500/30 rounded-lg text-amber-200/80 text-sm" data-id="element-151">
          <AlertTriangle size={18} className="shrink-0 mt-0.5 text-amber-500" data-id="element-152" />
          <p data-id="element-153">
            Complete all habits to unlock the finalize button. Unfinalized days
            will result in a reset at midnight.
          </p>
        </div>}

      <motion.button whileHover={isComplete ? {
      scale: 1.02
    } : {}} whileTap={isComplete ? {
      scale: 0.98
    } : {}} onClick={onFinalize} disabled={!isComplete} className={`w-full py-4 rounded-lg font-bold text-lg tracking-wider uppercase transition-all flex items-center justify-center gap-2 ${isComplete ? 'bg-centurion-500 hover:bg-centurion-400 text-surface-600 shadow-[0_0_20px_rgba(245,158,11,0.3)]' : 'bg-surface-200 text-gray-500 cursor-not-allowed border border-surface-100'}`} data-id="element-154">
        <Lock size={20} data-id="element-155" />
        {isComplete ? 'Finalize & Lock Day' : 'Incomplete'}
      </motion.button>
    </div>;
}